import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { BackendLink, NewsCard } from '../../../Components';
import './SmartNewsCardPage.css';

const SmartNewsCardPage = () => {
    const [newsData, setNewsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${BackendLink}/AllNews/`);
                if (!response.ok) throw new Error('Server error');
                const data = await response.json();
                setNewsData(data);
                if (data.length === 0) setError(true); // لو مفيش بيانات
            } catch (err) {
                console.error('Fetch error:', err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading || error) {
        return Array.from({ length: 6 }).map((_, i) => (
            <li key={i} className="smart-skeleton-card">
                <Skeleton
                    className='skeltonNews-img'
                    height={200}
                    width={250}
                    baseColor="var(--bg-footer)"
                    highlightColor="var(--bg-body)"
                />
                <div className='skeletonContent'>
                    <Skeleton
                        className='skeltonNews-tit'
                        height={25}
                        style={{ marginTop: '10px' }}
                        baseColor="var(--bg-footer)"
                        highlightColor="var(--bg-body)"
                    />
                    <Skeleton
                        className='skeltonNews-date'
                        height={10}
                        style={{ marginTop: '10px' }}
                        baseColor="var(--bg-footer)"
                        highlightColor="var(--bg-body)"
                    />
                    <Skeleton
                        className='skeltonNews-para'
                        count={3}
                        style={{ marginTop: '10px' }}
                        baseColor="var(--bg-footer)"
                        highlightColor="var(--bg-body)"
                    />
                </div>
            </li>
        ));
    }

    return newsData.map((newsItem) => (
        <NewsCard
            key={newsItem.id}
            image={newsItem.image}
            title={newsItem.title}
            date={newsItem.date}
            paragraph={newsItem.paragraph}
        />
    ));
};

export default SmartNewsCardPage;
